import React from "react";
import Skeleton from "@mui/material/Skeleton";
import CardNotifications from "../cardNotifications";
import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "../../styles";

interface Props {
  className: string;
  setModalNotifications: Function;
  cards: any;
  cardsReaded: any;
  setTotalItensRetorno: Function;
  totalItensRetorno: number;
  loading: boolean;
  firstLoad: boolean;
  setFirstLoad: Function;
  top?: string;
}

const modalNotifications: React.FC<Props> = ({
  className,
  setModalNotifications,
  cards,
  cardsReaded,
  setTotalItensRetorno,
  totalItensRetorno,
  loading,
  firstLoad,
  setFirstLoad,
  top,
}) => {
  const handleScroll = (e: any) => {
    setFirstLoad(false);
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      setTotalItensRetorno(totalItensRetorno + 10);
    }
  };

  return (
    <Styles.ModalNotifications className={className}>
      <Styles.ModalBG onClick={() => setModalNotifications(false)} />
      <Styles.ModalContent top={top || "15"}>
        <Styles.Row className="notifications-header">
          <IconsSVG.NotificationsModalIcon />
          <Styles.NotificationsTitleModal>
            Notificações
          </Styles.NotificationsTitleModal>
        </Styles.Row>
        <Styles.NotificationsList onScroll={handleScroll}>
          <Styles.CardsType>Não lido</Styles.CardsType>
          {loading && firstLoad ? (
            <>
              <Skeleton
                variant="rectangular"
                width="98%"
                height={72}
                style={{ marginBottom: 8 }}
              />
              <Skeleton variant="rectangular" width="98%" height={72} />
            </>
          ) : (
            <>
              {cards?.length > 0 ? (
                <>
                  {cards?.map((item: any) => {
                    return (
                      <CardNotifications
                        type={item?.tipoNotificacao}
                        dataNotificacao={item?.dataHoraNotificacao}
                        textNotificacao={item?.mensagem}
                        idLeadCorretor={item?.idLeadCorretor}
                        setModalNotifications={setModalNotifications}
                      />
                    );
                  })}
                </>
              ) : (
                <Styles.Text
                  style={{
                    textAlign: "center",
                    marginTop: 40,
                    paddingBottom: 40,
                  }}
                >
                  Nenhuma notificação não lida
                </Styles.Text>
              )}
            </>
          )}
          <Styles.CardsType>Lido</Styles.CardsType>
          {loading && firstLoad ? (
            <>
              <Skeleton
                variant="rectangular"
                width="98%"
                height={72}
                style={{ marginBottom: 8 }}
              />
              <Skeleton variant="rectangular" width="98%" height={72} />
            </>
          ) : (
            <>
              {cardsReaded?.length > 0 ? (
                <>
                  {cardsReaded?.map((item: any) => {
                    return (
                      <CardNotifications
                        className="card-read"
                        type={item?.tipoNotificacao}
                        dataNotificacao={item?.dataHoraNotificacao}
                        textNotificacao={item?.mensagem}
                        idLeadCorretor={item?.idLeadCorretor}
                        setModalNotifications={setModalNotifications}
                      />
                    );
                  })}
                </>
              ) : (
                <Styles.Text
                  style={{
                    textAlign: "center",
                    marginTop: 40,
                    paddingBottom: 40,
                  }}
                >
                  Nenhuma notificação lida
                </Styles.Text>
              )}
            </>
          )}
        </Styles.NotificationsList>
      </Styles.ModalContent>
    </Styles.ModalNotifications>
  );
};

export default modalNotifications;
